import { render } from "./AdminHead.vue?vue&type=template&id=8605fc00&scoped=true&ts=true"
import script from "./AdminHead.vue?vue&type=script&lang=ts"
export * from "./AdminHead.vue?vue&type=script&lang=ts"

import "./AdminHead.vue?vue&type=style&index=0&id=8605fc00&lang=css"
import "./AdminHead.vue?vue&type=style&index=1&id=8605fc00&scoped=true&lang=css"
import "./AdminHead.vue?vue&type=style&index=2&id=8605fc00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8605fc00"]])

export default __exports__